export const ICON_ARROW_WIDTH = 10;

export enum CustomHeaderTestIDs {
  NextMonthButton = 'SessionDatePicker.CustomHeaderTestID.NextMonthButton',
  PreviousMonthButton = 'SessionDatePicker.CustomHeaderTestID.PreviousMonthButton',
}
